import React from 'react';
import { Icon } from '@iyunbao/components';
import { wechat } from '@iyunbao/utils';

export interface InputProps {
  prefixCls?: string;
  type?: 'idcard' | 'bankcard';
  onChange?: (value: string) => void;
  onLog?: (name: string) => void;
}

// 表单 输入框组件
function openAddress(props: InputProps) {
  const { prefixCls = 'crm-input-wechat-address', onChange } = props;

  function onChangeValue() {
    const { channel = 'btbx_gzh' } = this.props;

    wechat.config({
      jsApiList: ['openAddress'],
      channel,
      debug: false,
    });

    // 加载完成
    wechat.ready((wx) => {
      wx.openAddress({
        success: (res) => {
          const { provinceName, cityName, detailInfo } = res || {};
          onChange && onChange(`${provinceName}${cityName}${detailInfo}`);
        },
      });
    });
  }

  return (
    <div className={prefixCls} onClick={() => onChangeValue()}>
      <Icon type="dingwei" />
    </div>
  );
}

export default openAddress;
